import { connect } from 'react-redux';

import ThreadListContainer from '../../MessagesTemplate/ThreadTemplate/ThreadListTemplateContainer';

import { getChatById } from '../actions';

const CurrentThreadContainer = (props) => <ThreadListContainer {...props} />;

const mapStateToProps = (state) => {
  const {
    messages: { currentChat },
    buildings,
  } = state;
  return {
    chatMessages: currentChat?.results,
    nextChatMessages: currentChat?.next,
    count: currentChat?.count,
    buildings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getChatById: (chatId, queryParams) =>
    getChatById(dispatch, chatId, queryParams),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CurrentThreadContainer);
